import { isMl3App } from './DeviceOptions';
import Cookies from './Cookies';
import { resolveLang } from 'common/handleLocale';

/** @type {false | { coords: { latitude: number; longitude: number; }; }} */
let definedCoords = false;

// set definedCoords -> ?coords=20.1233,124.123321
// unset definedCoords -> ?uncoords=1
const checkHasDefinedCoords = () => {
  const setKey = 'coords';
  const unsetKey = 'uncoords';
  const url = new URL(window.location.href);

  if (url.searchParams.get(unsetKey)) {
    Cookies.remove(setKey);
    return;
  }

  let coords = url.searchParams.get(setKey);
  if (!coords) {
    coords = Cookies.get(setKey) || null;
  }

  if (coords) {
    Cookies.set(setKey, coords, { expires: 10000 });

    const [latitude, longitude] = coords.split(',');
    definedCoords = {
      coords: {
        latitude: parseFloat(latitude),
        longitude: parseFloat(longitude),
      },
    };
  }
};

checkHasDefinedCoords();

/**
 * @type {(options?: PositionOptions) => Promise<{coords:{latitude: number; longitude: number;}}>}
 */
export const getCurrentPosition = (options = {}, callbackFunctionName = "") => {
  return new Promise((resolve, reject) => {
    if (definedCoords) {
      return resolve(definedCoords);
    }

    try {
      if (isMl3App) {
        if (window.Ml3AppObjs.NativeCurrentPos) {
          const latitude = window.Ml3AppObjs.NativeCurrentPos.lat();
          const longitude = window.Ml3AppObjs.NativeCurrentPos.lng();

          return resolve({
            coords: {
              latitude,
              longitude,
            },
          });
        }

        // Create callback function with name
        if (callbackFunctionName != "") {
          window.Ml3AppObjs[callbackFunctionName] = () => {
            if (window.Ml3AppObjs.NativeCurrentPos) {
              const latitude = window.Ml3AppObjs.NativeCurrentPos.lat();
              const longitude = window.Ml3AppObjs.NativeCurrentPos.lng();

              return resolve({
                coords: {
                  latitude,
                  longitude,
                },
              });
            }

            reject(new Error(resolveLang('位置情報取得に失敗しました')));
          };
        } else {
          window.Ml3AppObjs.NativeLocationCallback = () => {
            if (window.Ml3AppObjs.NativeCurrentPos) {
              const latitude = window.Ml3AppObjs.NativeCurrentPos.lat();
              const longitude = window.Ml3AppObjs.NativeCurrentPos.lng();

              return resolve({
                coords: {
                  latitude,
                  longitude,
                },
              });
            }

            reject(new Error(resolveLang('位置情報取得に失敗しました')));
          };
        }

        return;
      }

      window.navigator.geolocation.getCurrentPosition(
        resolve,
        () => {
          reject(
            new Error(resolveLang('現在地取得のため位置情報を許可してください'))
          );
        },
        options
      );
    } catch (e) {
      reject(new Error(resolveLang('現在地が取得できませんでした。')));
    }
  });
};

/**
 * @param {(position: {coords:{latitude: number; longitude: number;}}) => void} successCallback
 * @param {(e: Error) => void} errorCallback
 */
export const watchPosition = (successCallback, errorCallback = (() => undefined)) => {
  // // * if watchPosition is used, getCurrentPosition becomes laggy
  // // * so has to use setInterval
  // return window.navigator.geolocation.watchPosition(
  //   successCallback,
  //   errorCallback
  // );

  return setInterval(() => {
    getCurrentPosition().then(successCallback).catch(errorCallback);
  }, 3000);
};

/**
 * @param {NodeJS.Timeout} id
 */
export const clearWatch = (id) => clearInterval(id);
